(function () {
  function initGallery(sectionId) {
    var container = document.getElementById('VariantGallery-' + sectionId);
    if (!container) return;

    // Thumb clicks
    container.addEventListener('click', function (e) {
      var thumb = e.target.closest('.variant-gallery__thumb');
      if (!thumb) return;
      activateThumb(sectionId, thumb);
    });

    // Prev/next nav buttons
    container.querySelectorAll('.variant-gallery__nav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isPrev = btn.classList.contains('variant-gallery__nav--prev');
        navigate(sectionId, isPrev ? -1 : 1);
      });
    });

    // Finger swipe on the main image (left = next, right = previous)
    var main = document.getElementById('VariantGalleryMain-' + sectionId);
    // Quick view stacks all images vertically, so there is nothing to swipe through
    if (main && !main.closest('#Product-QuickView-Details')) {
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var SWIPE_MIN = 40;

      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      main.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var swipeLeft = dx < 0;
        if (webvista.isRTL()) swipeLeft = !swipeLeft;
        navigate(sectionId, swipeLeft ? 1 : -1);
      }, { passive: true });
    }

    updateNavButtons(sectionId);
  }

  function activateThumb(sectionId, thumb) {
    var src = thumb.dataset.src;

    var mainContainer = document.getElementById('VariantGalleryMain-' + sectionId);
    if (mainContainer) {
      mainContainer.querySelectorAll('.variant-gallery__main-img').forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.src === src);
      });
    }

    var thumbsContainer = document.getElementById('VariantGalleryThumbs-' + sectionId);
    if (thumbsContainer) {
      thumbsContainer.querySelectorAll('.variant-gallery__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumb.classList.add('is-active');
    updateNavButtons(sectionId);
  }

  function navigate(sectionId, direction) {
    var thumbsContainer = document.getElementById('VariantGalleryThumbs-' + sectionId);
    if (!thumbsContainer) return;

    var thumbs = Array.from(thumbsContainer.querySelectorAll('.variant-gallery__thumb'));
    if (!thumbs.length) return;

    var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    // Wrap around so the arrows never become dead clicks
    var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;

    activateThumb(sectionId, thumbs[nextIndex]);
  }

  function updateNavButtons(sectionId) {
    var container = document.getElementById('VariantGallery-' + sectionId);
    var thumbsContainer = document.getElementById('VariantGalleryThumbs-' + sectionId);
    if (!container || !thumbsContainer) return;

    var thumbs = Array.from(thumbsContainer.querySelectorAll('.variant-gallery__thumb'));
    var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });

    var prevBtn = container.querySelector('.variant-gallery__nav--prev');
    var nextBtn = container.querySelector('.variant-gallery__nav--next');
    // Only disable when there is nothing to cycle to
    var disabled = thumbs.length <= 1;
    if (prevBtn) prevBtn.disabled = disabled;
    if (nextBtn) nextBtn.disabled = disabled;
  }

  function updateGallery(sectionId, variantId) {
    var dataEl = document.getElementById('VariantGalleryData-' + sectionId);
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var images = data[String(variantId)];
    if (!images || images.length === 0) return;

    var mainContainer = document.getElementById('VariantGalleryMain-' + sectionId);
    if (mainContainer) {
      mainContainer.innerHTML = images
        .map(function (img, i) {
          return (
            '<img class="variant-gallery__main-img' + (i === 0 ? ' is-active' : '') + '" ' +
            'data-src="' + img.src + '" src="' + img.src + '" ' +
            'loading="' + (i === 0 ? 'eager' : 'lazy') + '" alt="" width="1200" height="1200">'
          );
        })
        .join('');
    }

    var thumbsContainer = document.getElementById('VariantGalleryThumbs-' + sectionId);
    if (thumbsContainer) {
      thumbsContainer.innerHTML = images
        .map(function (img, i) {
          return (
            '<button class="variant-gallery__thumb' + (i === 0 ? ' is-active' : '') + '" ' +
            'data-src="' + img.src + '" type="button">' +
            '<img src="' + img.thumb + '" loading="lazy" alt="" width="200">' +
            '</button>'
          );
        })
        .join('');
    }

    updateNavButtons(sectionId);
  }

  function preloadGalleryImages(sectionId) {
    var dataEl = document.getElementById('VariantGalleryData-' + sectionId);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    Object.values(data).forEach(function (images) {
      images.forEach(function (img) {
        var el = new Image();
        el.src = img.src;
      });
    });
  }

  document.querySelectorAll('[id^="VariantGallery-"]').forEach(function (el) {
    initGallery(el.dataset.section);
    preloadGalleryImages(el.dataset.section);
  });

  webvista.subscribe('variant-change', function (event) {
    var variant = event.data && event.data.variant;
    if (!variant) return;
    updateGallery(event.data.sectionId, variant.id);
  });
})();
